import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Conf01View from '@/views/Conf01View.vue';
import Ordc01View from '@/views/Ordc01View.vue';
import Payc01View from '@/views/Payc01View.vue';
import Cont01View from '@/views/Cont01View.vue';
import Erro01View from '@/views/Erro01View.vue';
import Erro02View from '@/views/Erro02View.vue';
import Erro03View from '@/views/Erro03View.vue';

// eslint-disable-next-line
import TestSubs from '@/views/testSubs.vue';
// eslint-disable-next-line
import TestCafe from '@/views/testCafe.vue';
// eslint-disable-next-line
import TestBenp from '@/views/testBenp.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/order-confirm',
    name: 'Conf01',
    component: Conf01View,
    meta: { requiresAuth: true },
  },
  {
    path: '/pay-complete',
    name: 'Payc01',
    component: Payc01View,
    meta: { requiresAuth: true },
  },
  {
    path: '/order-complete',
    name: 'Ordc01',
    component: Ordc01View,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/v1/fellowtravelers/CompanionOrder',
    name: 'Cont01',
    component: Cont01View,
  },
  /* {
    path: '/test',
    name: 'TestSubs',
    component: TestSubs,
  }, */
  {
    path: '/403',
    name: 'Erro01',
    component: Erro01View,
  },
  {
    path: '/ft-benefit-applying-error',
    name: 'Erro02',
    component: Erro02View,
  },
  {
    path: '/unmatch-ordersite-error',
    name: 'Erro03',
    component: Erro03View,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, _from, next) => {
  if (to.path.startsWith('/403') || to.path.startsWith('/ft-benefit-applying-error') || to.path.startsWith('/unmatch-ordersite-error')) {
    next();
    return;
  }

  if (!routes.some((route) => to.path === route.path)) {
    next({
      name: 'Erro01',
    });
    return;
  }

  next();
});

export default router;
